<!-- @Author: ruiwang -->
<!-- @Date: 2024-02-25 14:46:43 -->
<!-- @Last Modified by: xiaodongyu -->
<!-- @Last Modified time: 2024-02-28 19:39:02 -->

<template>
    <div
        v-if="finance.bought"
        class="container trade-record-page"
    >
        <section>
            <h1 class="bold">
                取引履歴
            </h1>
        </section>
        <section class="mt28">
            <div class="info-card des-group">
                <div
                    v-for="(option, idx) in options1"
                    :key="idx"
                    class="des-group-row b3"
                >
                    <div class="des-group-row-label bold">
                        {{ option.label }}
                    </div>
                    <div class="des-group-row-value pdf-row">
                        <template v-if="idx === options1.length - 2">
                            <a
                                v-for="(name, urlIdx) in pdfs"
                                :key="urlIdx"
                                class="pdf-item mr40"
                                :href="`/static/pdf/${name}.pdf`"
                                target="_blank"
                            >
                                <div class="pdf-item-wrapper">
                                    <pdf-svg />
                                    {{ pdfDisplayNameMap[name] }}.pdf
                                </div>
                            </a>
                        </template>
                        <div v-else>
                            {{ option.value }}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
    <i-empty v-else />
</template>

<script>
import {mapState} from 'vuex';

import {genOptions} from 'instacash/app/finance/profile/options';
import PdfSvg from 'instacash/common/component/finance/footer/pdf.vc.svg';
import {pdfDisplayNameMap} from 'instacash/common/constant';

import {options1} from './options';
export default {
    name: 'ProfilePage',

    components: {
        PdfSvg
    },

    data() {
        return {
            options1: genOptions(options1),
            pdfDisplayNameMap,
            pdfs: [
                'anonymous', 'contract-before', 'contract'
            ]
        };
    },

    computed: mapState(['finance'])
};
</script>

<style lang="scss" scoped>
.mt28 {
    margin-top: 0.28rem;
}

.mr40 {
    margin-right: 0.4rem;
}

.trade-record-page {
    h1 {
        color: $c-01;
    }

    .info-card {
        padding: 0.28rem 0.48rem 0.14rem;
        border-radius: 0.16rem;
        border: 1px solid $c-06;
    }

    .pdf-row {
        display: flex;
        align-items: center;
    }

    .pdf-item {
        color: inherit;
        transition: color 0.3s;

        &:hover {
            color: $yellow-02;
        }

        &-wrapper {
            display: flex;
            align-items: center;

            svg {
                margin-right: 0.03rem;
            }
        }
    }
}
</style>

